"use strict";
// Feature: address-geolocation, Task 4.1
//
// StubReverseGeocodingProvider — a deterministic default
// `ReverseGeocodingProvider` implementation.
//
// Reverse geocoding is display-only (Req 7.2, 7.3). Its output MUST NOT be
// persisted as a canonical `Address` — this stub returns opaque display text
// that reads like a coordinate label, so if a caller accidentally writes it
// back it will still be clearly non-canonical.
Object.defineProperty(exports, "__esModule", { value: true });
exports.StubReverseGeocodingProvider = void 0;
/**
 * Format a decimal number to N places without exponent notation.
 */
function fixed(n, digits) {
    if (!Number.isFinite(n))
        return "";
    return n.toFixed(digits);
}
/**
 * `StubReverseGeocodingProvider` — pure, deterministic. Returns a
 * `ReverseGeocodeDisplay` whose `displayText` includes the coordinates
 * (so it is unambiguously derived, never a canonical postal address).
 *
 * Returns `null` for non-finite coordinates so the caller reports the
 * failure per Req 6.4 (leave state unchanged).
 */
class StubReverseGeocodingProvider {
    async reverse(latitude, longitude) {
        if (!Number.isFinite(latitude) || !Number.isFinite(longitude))
            return null;
        return {
            displayText: `Near ${fixed(latitude, 5)}, ${fixed(longitude, 5)}`,
        };
    }
}
exports.StubReverseGeocodingProvider = StubReverseGeocodingProvider;
